import React from 'react';
import {browserHistory} from 'react-router';
import {modal} from '../../core/utilities/modal';
import {phoneNumberFormatter} from '../../helpers/General/PhoneNunberFormatter';
import {payable} from '../../core/controllers/Payable';

export default class VendorLoginCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            phoneNumber: "",
            readyForVerificationCode: false,
            verificationCode: ""
        };

    }

    componentDidMount() {

    }

    handleVendorPhoneChange(e) {
        var phoneNumber = phoneNumberFormatter.format(e.target.value);
        this.setState({
            phoneNumber: phoneNumber
        })
    }

    handleVerificationCodeChange(e) {
        this.setState({
            verificationCode: e.target.value
        })
    }

    validatePhoneNumber() {
        var phoneNum = this.state.phoneNumber;

        if (!/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(phoneNum)) {
            modal.showInfo("Please enter a valid phone number!", "warning", "top", "center");
            return false
        }

        return true
    }

    backToLogin() {
        browserHistory.replace('/login');
    }

    onSignInVendor() {
        var self = this;

        if (!this.validatePhoneNumber()) {
            return;
        }

        payable.sendVendorVerificationCode(this.state.phoneNumber, function(response) {
            modal.showInfo("A verification code has been sent to the email associated with this phone!", "success", "top", "center");
            self.setState({
                readyForVerificationCode: true
            })
        })
    }

    onSubmitVerificationCode() {
        payable.verifyVerificationCode(this.state.verificationCode, function(response) {
            modal.showInfo("Successfully verified!", "success", "top", "center");
            browserHistory.push('/');
        })
    }

    render() {
        const needsCode = (this.state.readyForVerificationCode === false);
        const phoneNumber = this.state.phoneNumber;

        return (
            <div className="new-login-card vendor-login">
                <div className="">
                    <h4 className="title login-right-panel-text">Welcome to Leasey</h4>
                </div>
                <div className="login-box-body">
                    {needsCode ? (
                        <p className="category">Enter the phone number associated with your account to login.</p>
                    ) : (
                        <p className="category vendor_phone">Please enter the verification code you just received:</p>
                    )}
                    <p className="login-box-msg"><span/></p>
                    <div>
                        <div className="form-group has-feedback">
                            {needsCode ? (
                                <div>
                                    <input type="text" className="form-control" placeholder="Vendor's Phone Number" value={phoneNumber} onChange={this.handleVendorPhoneChange.bind(this)}/>
                                    <i className="form-control-feedback fa fa-phone"/>
                                </div>
                            ) : (
                                <div>
                                    <input type="text" className="form-control" placeholder="Verification Code" onChange={this.handleVerificationCodeChange.bind(this)}/>
                                    <i className="form-control-feedback icon-key"/>
                                </div>
                            )}
                        </div>
                        <div className="row login-inputs">
                            <div className="loading">
                                <i className="fa fa-cog fa-spin"/>
                            </div>
                            <div className="col-md-6 col-md-offset-3">
                            {needsCode ? (
                                <button onClick={this.onSignInVendor.bind(this)} className="login-input btn btn-login-fill btn-block btn-flat">Send
                                    Code </button>
                            ) : (
                                <button type="submit" onClick={this.onSubmitVerificationCode.bind(this)} className="btn btn-info btn-login-fill btn-block btn-flat login">Validate
                                    Code </button>
                            )}
                            </div>
                        </div>
                        <div className="row text-center no-margin" style={{padding: "30px"}}>
                            {needsCode ? (
                                <p className="no-margin"> Not a vendor? Return
                                    to <a onClick={this.backToLogin} className="register">Login</a></p>
                            ) : (
                                <p>Didn't get a
                                    code? <a onClick={this.onSignInVendor.bind(this)} className="register">Resend</a>
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/components/VendorLogin/VendorLoginCard.jsx